import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '../../_services';
import {emailValidator} from '../../_validators/validators';
import {Router} from '@angular/router';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {

  public forgetPasswordForm: FormGroup;
  public submitted: boolean;
  public loading: boolean;
  public error: '';
  public success: '';
  public serverResponse: any;
  private passwordResetUrl: string;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {
    this.forgetPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, emailValidator]],
    });
  }


  ngOnInit(): void {
    this.passwordResetUrl = 'password-reset';
  }

  get f() {
    return this.forgetPasswordForm.controls;
  }

  sendPasswordResetLink() {
    this.loading = true;
    this.authenticationService.sendPasswordResetLink(this.f.email.value)
      .subscribe(resp => {
        this.serverResponse = resp;
        if (this.serverResponse.success === false) {
          this.loading = false;
          this.success = '';
          this.error = this.serverResponse.data;
        } else {
          this.loading = false;
          this.error = '';
          this.success = this.serverResponse.data;

          this.router.navigate([this.passwordResetUrl]);
        }
      });
  }
}
